/**
 * Rodzaj rekordu, do którego coś się odnosi — wspólny enum backendu
 * (`domain/fields/shared/model/target/TargetType`), ten sam, którym adresowane
 * są pola własne i wpisy powiązane.
 *
 * Front trzyma pełną listę, choć rysuje dziś garść wartości: typ przychodzi
 * z serwera, więc musi się rozpakować także wtedy, gdy ekran nie ma dla niego
 * widoku. Osobno od `TaggableType` z modułu tagów — backend rozdziela oba
 * enumy celowo, bo tagować można mniej rzeczy, niż da się zaadresować.
 */
export enum TargetType {
  PARTICIPANT = 'PARTICIPANT',
  TOUR = 'TOUR',
  CLIENT = 'CLIENT',
  PLANNED_TRANSACTION = 'PLANNED_TRANSACTION',
  TRANSACTION = 'TRANSACTION',
  WAITLIST_ENTRY = 'WAITLIST_ENTRY',
  BOOKING = 'BOOKING',
  BOOKING_CHANGE = 'BOOKING_CHANGE',
  RAW_TRANSACTION = 'RAW_TRANSACTION',
  GLOBAL_TRANSACTION = 'GLOBAL_TRANSACTION',
  MESSAGE = 'MESSAGE',
  TOUR_OPTION = 'TOUR_OPTION',
  INVITATION = 'INVITATION',
  USER = 'USER',
  CONSENT_TEMPLATE = 'CONSENT_TEMPLATE',
  ACCEPTED_CONSENT = 'ACCEPTED_CONSENT',
  DISCOUNT = 'DISCOUNT',
  TOUR_EXPENSE = 'TOUR_EXPENSE',
  COST_CATEGORY = 'COST_CATEGORY',
  INSURED_PARTICIPANT = 'INSURED_PARTICIPANT',
  CLIENT_WITH_INSURANCE = 'CLIENT_WITH_INSURANCE',
  INSURANCE = 'INSURANCE',
}

/** Typy będące osobą — mają imię, nazwisko i własny ekran. */
export type PersonTargetType = TargetType.CLIENT | TargetType.PARTICIPANT;

export const isPersonTarget = (
  targetType: TargetType,
): targetType is PersonTargetType =>
  targetType === TargetType.CLIENT || targetType === TargetType.PARTICIPANT;
